// The map card's body box: CompassView and SecretMapView both draw into this
// same local SVG coordinate space, so it lives here once instead of as two
// copies that could drift apart (the bug this file fixes: the two views used
// to assume the card was the full 552x552 dossier-card square, which the
// card no longer is now that the mic/keyboard chips stay on screen during a
// walk — see MapCard.tsx's CARD_HEIGHT comment).
//
// Derived from the dossier card's own metrics (dossier.css): padding is 32
// top/right/bottom, 40 left; the header is 56 tall; the rule (its 16px
// margin-top, 3px height, 24px margin-bottom) is 43.
import { CARD_HEIGHT, CARD_WIDTH } from './MapCard';

const PADDING_X = 40 + 32; // left 40, right 32
const PADDING_Y = 32 + 32; // top 32, bottom 32
const HEADER_H = 56;
const RULE_H = 43;

export const BOX_W = CARD_WIDTH - PADDING_X;
export const BOX_H = CARD_HEIGHT - PADDING_Y - HEADER_H - RULE_H;
